import React from 'react';
import styled from 'styled-components';
import BSGLOGO from '../../assets/icons/BSG.png';
import NewFooter from '../../components/Footer/NewFooter';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const HeaderContainer = styled.header`
  background-color: #53a8a0;
  display: flex;
  align-items: center;
  display: flex;
  height: 80px;
  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
`;
const Logo = styled.img`
  width: 50px;
  height: 50px;
`;
const LogoContainer = styled.div`
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: #e9e9e9;
`;

const ContainerIn = styled.div`
  width: 80%;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 90%;
  }
`;

const AboutHeading = styled.h2`
  text-align: center;
  margin-top: 40px;
  font-size: 29px;
  font-family: sans-serif;
`;

const Content = styled.div`
  margin: 0 auto;
  height: 100%;
`;
const ContentPara = styled.p`
  text-align: center;
  font-size: 20px;
  margin-top: 35px;
  //   position: relative;
  //   display: inline-block;
  color: #479081;
`;
// const Anchor = styled.a`
//   text-align: center;
//   color: #4d887c;
//   word-break: break-word;
// `;
const NoticeText = styled.p`
  text-align: center;
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
`;
const Delivery = () => {
  const navigate = useNavigate();
  const TITLE = 'Delivery and Shipment - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <HeaderContainer>
        <LogoContainer onClick={() => navigate('/login')}>
          <Logo src={BSGLOGO} alt="Logo" />
        </LogoContainer>
      </HeaderContainer>
      <Container>
        <ContainerIn>
          <AboutHeading>Delivery And Shipment</AboutHeading>
          <Content>
            <ContentPara>Delivery and Shipment (if applicable)</ContentPara>
            <br />
            <p style={{ textAlign: 'center', margin: 0 }}>
              {' '}
              Terms and conditions as mentioned under refund and cancellation
              policy.
            </p>
            <Box sx={{ marginTop: '100px' }}>
              <NoticeText>
                “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR
                MAKING CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES
                CONTRIBUTION THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR
                CONTRIBUTION.”
              </NoticeText>
            </Box>
          </Content>
        </ContainerIn>
      </Container>
      <NewFooter />
    </>
  );
};

export default Delivery;
